import React from "react";
import Kristi from '../assets/images/kristi.jpg';
import SecondTile from '../assets/images/usa-cia-agent-combating-organized-crime-terrorism-using-surveillance_482257-105847.jpg';
import ThirdTile from '../assets/images/IWUPFMK5VFICLGDUVPGG5ULUJU.jpg';

const CrimeTile = () => {
  const tiles = [
    {
      title: "Cybersecurity Awareness Month",
      description:
        "January highlights the need to secure your digital identity. Stay vigilant against cyber threats.",
      image: Kristi,
      speaker: "- Kristi Noem, Homeland Security Secretary",
    },
    {
      title: "Combating Organized Crime",
      description:
        "Law enforcement is ramping up efforts to dismantle criminal networks threatening public safety.",
      image: SecondTile,
      speaker: "- Jane Smith, Federal Agent",
    },
    {
      title: "Meta Community Safety Resources",
      description:
        "Empowering communities to stay vigilant against cybercrime fosters a safer digital space.",
      image: ThirdTile,
      speaker: "- Barr. Maureen Louise, Meta Attorney",
    },
  ];

  return (
    <div className="px-6 py-14 bg-[#ccd5ae]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {tiles.map((tile, index) => (
          <div
            key={index}
            className="bg-white shadow-lg rounded-xl overflow-hidden transform transition-all hover:scale-105 hover:shadow-xl relative"
          >
            <div className="relative">
              <img
                src={tile.image}
                alt={tile.title}
                className="w-full h-auto object-cover rounded-t-xl"
              />
              {/* Overlay for image */}
              <div className="absolute inset-0  rounded-t-xl"></div>
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-bold text-gray-800 mb-2 hover:text-red-600 transition-colors">
                {tile.title}
              </h3>
              <p className="text-base text-gray-700 mb-3">{tile.description}</p>
              <p className="text-xs text-gray-500 italic">{tile.speaker}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CrimeTile;
